import styled from 'styled-components';

export const SearchContainer = styled.div`
    margin-left: 60px;
    gap: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

export const SearchFieldArea = styled.div`
    flex-shrink: 0;
    width: auto;
`;

export const SearchFieldWrapper = styled.div`
    display: flex;
    width: 320px;
    height: 46px;
    padding: 0;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    position: relative;
`;

export const SearchFieldInner = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 14px;
    gap: 8px;
    min-width: 0;
    position: relative;
`;

export const SearchInputWrapper = styled.div`
    flex: 1 1 0%;
    min-width: 0;
    width: 100%;
    position: relative;
`;

export const SearchIconWrapper = styled.div`
    flex-shrink: 0;
    z-index: 2;
    position: absolute;
    left: 14px;
`;

export const FakePlaceholder = styled.span`
    position: absolute;
    left: ${props => props.left || '42px'};
    top: 50%;
    transform: translateY(-50%);
    color: #98A2B3;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.2s ease;
`;

export const ClearButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    z-index: 2;
`;

// Global styles for search input (using CSS-in-JS)
export const searchInputStyles = `
    .search-container .search-label,
    .serach_field-area .search-label {
        width: 100% !important;
        margin-bottom: 0 !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
    }
    
    .search-container .search_field input,
    .serach_field-area .search_field input {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
        width: 100% !important;
        font-size: 16px !important;
        font-family: Inter !important;
        font-weight: 400 !important;
        color: #101828 !important;
        background: transparent !important;
        height: 100% !important;
        min-height: 46px !important;
        line-height: 24px !important;
        padding: 11px 0 11px 0 !important;
        margin: 0 !important;
        position: relative !important;
        z-index: 1 !important;
    }
    
    .search-container .search_field input:focus,
    .search-container .search_field input:active,
    .search-container .search_field input:focus-visible,
    .serach_field-area .search_field input:focus,
    .serach_field-area .search_field input:active,
    .serach_field-area .search_field input:focus-visible {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }
    
    .search-container .search_field input::placeholder,
    .serach_field-area .search_field input::placeholder {
        opacity: 0 !important;
    }
    
    .search-container .serach_field-area,
    .serach_field-area {
        flex-shrink: 0 !important;
        width: auto !important;
        max-width: none !important;
    }

    .react-datepicker__input-container button {
        margin-right: 16px !important;
    }
    
    .search-container .react-datepicker-wrapper {
        flex-shrink: 0 !important;
    }
    
    .search-container .search_field > div,
    .serach_field-area .search_field {
        width: 100% !important;
        min-width: 0 !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        padding: 0 14px !important;
        position: relative !important;
    }
`;

